import { parseCellId } from '@cards/engine';
import { afterCombat, cardRef, defineGameCard, fullRoomStatus, ongoing, } from '../authoring/index.js';
import { isLocationFullyFurnished } from './furniture_helpers.js';
const CLOCKWORK_OTTOMAN_ID = 'clockwork_ottoman';
export const ClockworkOttomanCard = defineGameCard({
    id: CLOCKWORK_OTTOMAN_ID,
    gameplay: { type: 'STRUCTURE', cost: 3, baseStats: { attack: 0, health: 6 } },
    presentation: {
        name: 'Заводной пуф',
        description: 'Пока его локация заполнена, ваши карты в ней получают +1/+1. После боя восстанавливает 1 здоровье вашим картам в этой локации.',
        glyph: {
            colors: ['#10213A', '#C04321', '#E06231', '#A7331B', '#7F2516'],
            rows: [
                '....................',
                '....................',
                '....................',
                '....111111111111....',
                '...12333333333321...',
                '..1233333333333321..',
                '..1233333333333321..',
                '..1223333333333221..',
                '..1222222222222241..',
                '..1244444444444451..',
                '..1555555555555551..',
                '...11111111111111...',
                '...15555555555551...',
                '...15444444444451...',
                '...15444444444551...',
                '...15555555545551...',
                '...15551111115551...',
                '....111......111....',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef(CLOCKWORK_OTTOMAN_ID)],
    abilities: [
        ongoing((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return [];
            if (!isLocationFullyFurnished(ctx, self.controllerId, self.cellId))
                return [];
            const tableId = parseCellId(self.cellId).tableId;
            return ctx.q.unitsOf(self.controllerId)
                .filter((card) => card.cellId !== undefined
                && parseCellId(card.cellId).tableId === tableId)
                .map((card) => ({
                abilityId: `full_location_allied_cards:${card.id}`,
                scope: { kind: 'unit', instanceId: card.id },
                // Structures need the generic permission in addition to attack: a
                // non-zero attack alone does not make a STRUCTURE a combatant.
                vars: { attackPermission: 'allow_non_unit' },
                statMods: [
                    { stat: 'attack', op: 'add', value: 1 },
                    { stat: 'maxHealth', op: 'add', value: 1 },
                ],
            }));
        }),
        afterCombat((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined)
                return;
            const tableId = parseCellId(self.cellId).tableId;
            const cards = ctx.q.unitsOf(self.controllerId)
                .filter((card) => card.cellId !== undefined && parseCellId(card.cellId).tableId === tableId);
            for (const card of cards)
                ctx.ops.restoreUnitHealth(card.id, 1, self.id);
        }),
    ],
    ui: { mechanics: ['full_room'], statusProviders: [fullRoomStatus()] },
});
//# sourceMappingURL=clockwork_ottoman.js.map